import { connect } from "react-redux";
import { postDoiTinhTrangNo } from "actions/DoiTinhTrangNo";
import DoiTinhTrangNo from "components/CommonComponent/DoiTinhTrangNo";

const mapStateToProps = (state) => ({
  inchovay: state.inchovay,
});

const mapDispatchToProps = (dispatch) => ({
  postDoiTinhTrangNo: (dataPost) => dispatch(postDoiTinhTrangNo(dataPost)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DoiTinhTrangNo);
